import React from 'react';

const PreviewSvg = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='21'
      viewBox='0 0 16 12'
      fill='none'
    >
      <path
        d='M8 0.5C3.22727 0.5 0.5 5.75 0.5 5.75C0.5 5.75 3.22727 11 8 11C12.7727 11 15.5 5.75 15.5 5.75C15.5 5.75 12.7727 0.5 8 0.5Z'
        stroke='#011211'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M8 8C9.24268 8 10.25 6.99268 10.25 5.75C10.25 4.50733 9.24268 3.5 8 3.5C6.75732 3.5 5.75 4.50733 5.75 5.75C5.75 6.99268 6.75732 8 8 8Z'
        stroke='#011211'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default PreviewSvg;
